export default "__VITE_ASSET__m3GR2l$v__"